import type { IconName } from '@/components/entities/Sprite/Icon';

export const FOOTER_INTERAC_ICON: IconName = 'footer-interac';

export const US_PAYMENT_ICONS: IconName[] = [
  'footer-visa',
  'footer-master-card',
  'footer-apple-pay',
  'footer-google-pay',
  'footer-pay-pal',
  'footer-cash-app',
];

// CA doesn't support PayPal or CashApp yet.
export const CANADA_PAYMENT_ICONS: IconName[] = [
  'footer-visa',
  'footer-master-card',
  'footer-apple-pay',
  'footer-google-pay',
];

export const MOBILE_SECOND_BLOCK_ICONS: IconName[] = [
  'footer-pay-pal',
  'footer-cash-app',
  'footer-crypto-icons',
];

export const DESKTOP_SECOND_BLOCK_ICONS: IconName[] = [
  'BTC',
  'ETH',
  'USDT-tether',
  'another-crypto',
];
